import { z } from "zod";
import { addressSchema } from "./IAddress"; // Zod schema for IAddress
import { companySchema } from "./ICompany"; // Zod schema for ICompany

export const customerSchema = z.object({
    id: z.number(),
    Title: z.number(),
    Gender: z.number(),
    LeadQuelle: z.string().nullable(),
    firstname: z.string(),
    lastname: z.string(),
    Address: addressSchema.optional(), // IAddress | undefined
    insured: z.boolean(),
    Insurance: z.number().nullable(),
    insuranceNumber: z.string(),
    tenant: z.boolean(),
    PropertyManagement: z.number().nullable(),
    tenantNumber: z.union([z.string(), z.number()]),
    b2b: z.boolean(),
    Company: companySchema.nullable().optional(), // ICompany | undefined
    telefon: z.string(),
    mobil: z.string(),
    isMerchant: z.boolean(),
    email: z.string(),
    birthplace: z.string().nullable(),
    birthday: z.string().nullable(),
    iban: z.string().nullable(),
});

export type ICustomer = z.infer<typeof customerSchema>;
